import styled from 'styled-components';
import PushPinIcon from '@mui/icons-material/PushPin';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

export const Item = styled.li`
  display: grid;
  grid-template-columns: 17px 1fr;
  align-items: center;
  grid-gap: 4px;
  padding: 4px 10px;

  span {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.cflowerBlue};

    &:hover {
      background: ${({ theme }) => theme.colors.gradient};
      -webkit-background-clip: text;
      color: transparent;
      cursor: pointer;
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    .MuiSvgIcon-root {
      font-size: 28px;
    }
  }
`;

// Single-column variant for items without a leading icon (was an inline grid-template-columns override).
export const ItemSingleCol = styled(Item)`
  grid-template-columns: 1fr;
`;

export const PinIcon = styled(PushPinIcon)`
  color: ${({ theme }) => theme.colors.cflowerBlue};
`;

export const SwitchIcon = styled(SwapHorizIcon)`
  color: ${({ theme }) => theme.colors.cflowerBlue};
`;
